import { LoginService } from './login.service';
import { PlanMainService } from './../plan/service/plan-main.service';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanLoad,
  Route
} from '@angular/router';
// import { StaffDetail } from './../models/staffLogin';
// import { apiUrl } from './../app.config';
import { Http } from '@angular/http';
import { DataService } from './data.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthGuard implements CanActivate, CanLoad, CanActivateChild {

  static headers = new Headers({ 'Content-Type': 'application/json' });
  public staffSubScription: Subscription;
  public ngUnsubscribe = new Subject();
  public defaultHeaders: Headers = new Headers();

  constructor(
    private router: Router,
    private loginService: LoginService,
    private planMainService: PlanMainService,
    // private _http: Http,
    private _data: DataService) { }

  checkValidate(): Observable<boolean> | boolean {
    if (environment.json === true) {
      this._data.token = '***';
      return true;
    }
    if (this._data.token) {
      if (this.loginService.subScription) {
        console.log('sub');
        return true;
      } else {
        console.log('not sub');
        return this.loginService
          .refreshToken(this._data.token)
          .map(data => {
            if (data) {
              this.loginService.isAuthenticated();
              return true;
            } else {
              this.loginService.clearDataAndNavigateToLogin();
              return false;
            }
          })
          .catch(e => {
            this.loginService.clearDataAndNavigateToLogin();
            return Observable.throw('Unauthorized');
          });
      }
    } else {
      console.log('no token');
      this.loginService.clearDataAndNavigateToLogin();
      return false;
    }
  }

  checkStafflogin(): Observable<boolean> | boolean {
    if (environment.json === true) {
      this.planMainService.staffDialog.next(true);
      return true;
    }
    const isStafflogin = this._data.staffData;
    if (isStafflogin && isStafflogin.results === true && this._data.token) {
      // this.loginService.isStaffAuthenticated('auth Guard');
      return true;
    } else {
      if (this.router.url !== '/planmain') {
        this.planMainService.staffDialog.next(true);
      } else {
        this.loginService.clearDataAndNavigateToLoginStaff();
      }
      return false;
    }
  }

  // refreshStaffAuth(token: string) {
  //   const path = `${apiUrl}` + `/staff/auth`;
  //   const headers = LoginService.headers;
  //   headers.set('auth', token);
  //   headers.set('Content-Type', 'application/json');
  //   // console.log(headers);
  //   return Observable.timer(0, 1 * 10 * 1000) // 4 mins
  //     .flatMap(() =>
  //       this._http.get(path, { headers: headers })
  //     )
  //     .map(response => response.json());
  // }

  // isStaffAuthenticated(who?: string) {
  //   const token = localStorage.getItem('token');
  //   const subject = new Subject<boolean>();

  //   this.staffSubScription = this.refreshStaffAuth(token)
  //     .takeUntil(this.ngUnsubscribe)
  //     .subscribe(
  //       (data: StaffDetail) => {
  //         if (data && data.kyotenCd && data.kyotenNm && data.staffCd && data.staffNm) {
  //           // subject.next(true);
  //           console.log({ isStaffLogin: true, who: who });
  //         } else {
  //           // subject.next(false);
  //           console.log({ isStaffLogin: false, who: who });
  //           this.clearDataAndNavigateToLoginStaff();
  //         }
  //       },
  //       error => {
  //         console.error(error);
  //         this.clearDataAndNavigateToLoginStaff();
  //       });
  //     return this.staffSubScription;
  // }

  // clearDataAndNavigateToLoginStaff() {
  //   // const staffData = localStorage.removeItem('staffData');
  //   this.ngUnsubscribe.next();
  //   this.ngUnsubscribe.complete();
  //   if (this.staffSubScription) {
  //     this.staffSubScription.unsubscribe();
  //     console.log('Unsub -> ');
  //   }
  //   localStorage.removeItem('staffData');
  //   localStorage.removeItem('staffId');
  //   this.router.navigate(['/home']);
  // }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return this.checkValidate();
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return this.checkStafflogin();
  }

  canLoad(route: Route): Observable<boolean> | boolean {
    return this.checkValidate() && this.checkStafflogin();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard.service.ts